import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=78aac7db&scoped=true"
import script from "./LoadingComponent.vue?vue&type=script&lang=ts"
export * from "./LoadingComponent.vue?vue&type=script&lang=ts"
import style0 from "./LoadingComponent.vue?vue&type=style&index=0&id=78aac7db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aac7db",
  null
  
)

export default component.exports